import { RadioGroup, RadioGroupItem } from '@commenda/kakashi';
import { OptionType } from '@commenda/utils';
import React from 'react';
import { FormInputWrapper } from '../../common';

type CommendaResidentDirectorFormProps = {
  optForResidentDirector: boolean;
  setOptForResidentDirector: React.Dispatch<React.SetStateAction<boolean>>;
  setOptForResidentDirectorError: React.Dispatch<
    React.SetStateAction<string | undefined>
  >;
};

const CommendaResidentDirectorForm = ({
  optForResidentDirector,
  setOptForResidentDirector,
  setOptForResidentDirectorError,
}: CommendaResidentDirectorFormProps) => {
  const optionValue = optForResidentDirector ? OptionType.YES : OptionType.NO;

  return (
    <FormInputWrapper
      id="optForResidentDirector"
      text="Are you planning to use Commenda's Indian Resident Director service?"
      description="To register a Private Limited Company in India, at least one director must be an Indian resident. If you don’t already have a resident director Commenda can provide one for you."
      isRequired
    >
      <div className="flex flex-col gap-2">
        <RadioGroup
          value={optionValue}
          className="flex flex-col gap-4"
          onValueChange={(val: OptionType) => {
            setOptForResidentDirector(val === OptionType.YES);
            setOptForResidentDirectorError(undefined);
          }}
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem
              size="lg"
              value={OptionType.YES}
              id="residentDirector-yes"
            />
            <label htmlFor="residentDirector-yes">Yes</label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem
              size="lg"
              value={OptionType.NO}
              id="residentDirector-no"
            />
            <label htmlFor="residentDirector-no">No</label>
          </div>
        </RadioGroup>
      </div>
    </FormInputWrapper>
  );
};

export { CommendaResidentDirectorForm };
